export const SN_PARTY = 'party'
export const PARTY_NAMES_BY_PARTY_ID_UPDATED = SN_PARTY + '/NAMES_BY_PARTY_ID_UPDATED'